export default __webpack_public_path__ + "assets/images/1c7744ee4245c4aca0d1e3b91e3eacff.png";